import { schema } from 'normalizr';

import { getAssignmentHashKey } from '@components/status-cell/helpers';

import { ENTITY_NAMES } from './constants';
import { getClassroomCourseVersionHashKey, getGroupHashKey } from './helpers';

export const assignment = new schema.Entity(ENTITY_NAMES.ASSIGNMENTS, undefined, {
  idAttribute: (value, parent) => getAssignmentHashKey(parent.studentUserProfileId, value.learningJourneyId)
});

export const studentWithAssignments = new schema.Entity(
  ENTITY_NAMES.STUDENTS,
  {
    assignments: [assignment]
  },
  {
    idAttribute: 'studentUserProfileId'
  }
);

const learningJourneyStep = new schema.Entity(ENTITY_NAMES.LEARNING_JOURNEY_STEPS);

const learningJourney = new schema.Entity(
  ENTITY_NAMES.LEARNING_JOURNEYS,
  {
    childTopics: [learningJourneyStep]
  },
  {
    processStrategy: (value, parent) => ({
      ...value,
      standardId: parent.id
    })
  }
);

const standard = new schema.Entity(ENTITY_NAMES.STANDARDS, {
  childTopics: [learningJourney]
});

const strand = new schema.Entity(ENTITY_NAMES.STRANDS, {
  childTopics: [standard]
});

const student = new schema.Entity(
  ENTITY_NAMES.STUDENTS,
  {},
  {
    processStrategy: (value, parent) => ({
      ...value,
      groupId: getGroupHashKey({ classroomId: parent.classroomId, groupId: parent.id })
    })
  }
);

const group = new schema.Entity(
  ENTITY_NAMES.GROUPS,
  {
    students: [student]
  },
  {
    // The group id only unique in the classroom level, so we give it a unique id with classroom id
    idAttribute: (value, parent) => getGroupHashKey({ classroomId: parent.id, groupId: value.id }),
    processStrategy: (value, parent) => ({ ...value, classroomId: parent.id })
  }
);

const lockedCourseVersion = new schema.Entity(ENTITY_NAMES.LOCKED_COURSE_VERSIONS, undefined, {
  idAttribute: (value, parent) => getClassroomCourseVersionHashKey({ courseId: value.id, classroomId: parent.id })
});

const classrooms = new schema.Entity(ENTITY_NAMES.CLASSROOMS, {
  groups: [group],
  lockedCourseVersions: [lockedCourseVersion]
});

const course = new schema.Entity(ENTITY_NAMES.COURSES);

const publication = new schema.Entity(ENTITY_NAMES.PUBLICATIONS, {
  courses: [course]
});

const Schema = {
  CLASSROOMS_ARRAY: [classrooms],
  PUBLICATION_ARRAY: [publication],
  STANDARDS_ARRAY: [standard],
  STRANDS_ARRAY: [strand],
  STUDENT_WITH_ASSIGNMENTS_ARRAY: [studentWithAssignments]
};

export default Schema;
